import { render, staticRenderFns } from "./create-closure.vue?vue&type=template&id=3b1d0b56&"
import script from "./create-closure.vue?vue&type=script&lang=ts&"
export * from "./create-closure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "create-closure.vue"
export default component.exports